

import { Card, CardContent } from '@mui/material'
import { PageLoader } from 'frame/components'

const LoadingView = ({ activeSection }) => {

  return (
    <Card>
      <CardContent
        sx={{
          paddingY: 3,
          paddingX: 1.2,
          '@media (min-width: 600px)': {
            padding: 3,
            minHeight: 'min(80vh, 600px)',
          },
        }}>
        <div
          style={{
            marginTop: 3,
          }}>
          <PageLoader minHeight={220} />
        </div>
      </CardContent>
    </Card>
  )
}

export default LoadingView

